import type {Evaluator} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {LightNode} from "#template/nodes/object/light/light-node"
import type {ObjectNodeDefinition, ObjectNodeParameters} from "#template/nodes/object/types"
import type {OnCompileContext, TemplateNodeContext, VisitorNodeResult} from "#template/template-node/types"
import {objectNodeParameters} from "#template/nodes/object/validation"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import type {SceneNodes} from "#template/interfaces/scene-object"
import {visitNone} from "#template/template-node/visit-helpers"

export type LightPortalParameters = {
    name: string
    width: number
    height: number
} & ObjectNodeParameters

const lightPortalDefinition: ObjectNodeDefinition<LightPortalParameters> = {
    nodeClass: "LightPortal",
    validation: {
        parameters: z.extend(
            z.object({
                name: z.string(),
                width: z.number(),
                height: z.number(),
            }),
            objectNodeParameters.shape,
        ),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class LightPortal extends LightNode<LightPortalParameters> {
    public override get definition() {
        return lightPortalDefinition
    }

    public override onCompile(context: OnCompileContext, _evaluator: Evaluator<TemplateNodeContext>): VisitorNodeResult<LightPortalParameters> {
        const {evaluator} = context
        const {width, height} = this.parameters

        const scope = evaluator.getScope(this)

        this.setupObject(scope, context, "LightPortal", undefined, undefined, (objectProps) => {
            return scope.struct<SceneNodes.LightPortal>("LightPortal", {
                type: "LightPortal",
                ...objectProps,
                width,
                height,
            })
        })

        return visitNone(this.parameters)
    }
}
